<template>
  <div class="footer">
    <div class="container">
      <div class="siteinfo">
        <div class="c0 siteinfo-item-1 cursorP" @click="gotoPayMethodPage">
          <h3 class="c1"><img src="../assets/images/footer/foot_payment_icon.png" class="footer-img">支付方式</h3>
          <ul class="siteinfo-list">
            <li class="c2">微信</li>
            <li class="c2">支付宝</li>
<!--            <li class="c2">企业网银支付</li>-->
            <li class="c2">银联卡</li>
            <li class="c2">其它支付</li>
          </ul>
        </div>
        <div class="c0 siteinfo-item-2">
          <h3 class="c1"><img src="../assets/images/footer/foot_contact_icon.png" class="footer-img">联系方式</h3>
          <ul class="siteinfo-list">
            <li class="c2">0571-87221111</li>
            <li class="c2">0551-69127696</li>
            <li class="c2">周一到周五</li>
            <li class="c2">9：00 - 18：00</li>
          </ul>
        </div>
        <div class="c0 siteinfo-item-3">
           <h3 class="c1"> <img src="../assets/images/footer/foot_adress_icon.png" class="footer-img">办公地址</h3>
          <ul class="siteinfo-list">
            <li class="c2">杭州: 杭州市江干区江秀街9号维多利大厦B幢11楼</li>
            <li class="c2">合肥: 合肥市包河区兰州路88号青网大厦16层</li>
          </ul>
        </div>
          <div class="QR-code">
              <div class="QR-code-item">
                  <img src="../assets/images/app_big.png">
                  <p>APP下载码</p>
              </div>
              <div class="QR-code-item">
                  <img src="../assets/images/weixin_big.png">
                  <p>青邦企服公众号</p>
              </div>
          </div>
      </div>
    </div>
    <div class="copyright">
        <div class="page-main">
            Copyright@2018-2021 安徽青友汇商务服务有限公司 皖ICP备17011519号
        </div>
      </div>
  </div>
</template>
<script>
  // import YButton from '/components/YButton'
  export default {
    data () {
      return {
      }
    },
    methods: {
        gotoPayMethodPage(){
            this.$router.push({ path: "/payMethod" });
        },
      open1 () {
        this.$notify.info({
          title: '法律声明',
          message: '此仅为个人练习开源模仿项目，仅供学习参考，承担不起任何法律问题'
        })
      },
      open2 () {
        this.$notify.info({
          title: '隐私条款',
          message: '本网站将不会严格遵守有关法律法规和本隐私政策所载明的内容收集、使用您的信息'
        })
      },
      open3 () {
        this.$notify({
          title: '离线帮助',
          message: '没人会帮助你，请自己靠自己',
          type: 'warning'
        })
      },
      open4 () {
        this.$notify.info({
          title: '支付方式',
          message: '支持支付宝、微信等方式捐赠'
        })
      },
      open5 () {
        this.$notify({
          title: '送货政策',
          message: '本网站所有商品购买后不会发货，将用作捐赠',
          type: 'warning'
        })
      }
    },
    components: {
      // YButton
    }
  }
</script>
<style lang="less" rel="stylesheet/less" scoped>
  .footer {
    font-size: 14px;
    background: #F5F5F5;
    /*margin-top: 60px;*/
  }
  .container {
    width: 100%;
  }
  .siteinfo {
   width: 1100px;
    height: 100px;
    padding: 50px 0 150px;
    border-bottom: 1px solid #e6e6e6;
    position: relative;
      margin: 0 auto;
  }
  .c0 {
    float: left;
      padding-left: 2%;
  }
  .footer-img{
      margin-bottom: -5px;
      margin-right: 12px;
  }
  .siteinfo-item-1{
      width: 15%;
      border-left: 1px dotted #B5B5B5;
  }
  .siteinfo-item-2{
      width: 17%;
      border-left: 1px dotted #B5B5B5;
      border-right: 1px dotted #B5B5B5;
  }
  .siteinfo-item-3{
      width: 24%;
  }
  .siteinfo-list{
      padding-left: 35px;
  }
  .c1 {
    color: #646464;
    padding: 0 0 14px;
  }

  .c2 {
    color: #585858;
  }

  .c3 {
    color: #969696;
  }

  .c4 {
    position: absolute;
    right: 0;
    overflow: hidden;
    line-height: 34px;
  }

  .tel {
    font-size: 30px;
    line-height: 1;
    color: #646464;
    top: -2px;
    position: relative;
  }

  .c5 {
    color: #646464;
    right: -70px;
    position: relative;
  }

  .time {
    margin-top: 5px;
    right: -4px;
    position: relative;
    clear: both;
    width: 241px;
    font-size: 12px;
    line-height: 18px;
    color: #c3c3c3;
    text-align: right;
  }

  .online {
    clear: both;
    width: 241px;
    font-size: 12px;
    line-height: 18px;
    color: #c3c3c3;
    text-align: right;
  }

  .button {
    width: 130px;
    height: 34px;
    font-size: 14px;
    color: #5079d9;
    border: 1px solid #dcdcdc;
    margin-top: 8px;
  }
  .QR-code{
      position: absolute;
      right: 0;
  }
  .QR-code-item{
      margin-left: 15px;
      float: left;
      padding: 1px 10px 0;
  }
  .QR-code-item img{
      width: 99px;
      height: 99px;
  }
  .QR-code-item p{
      text-align: center;
      font-size:14px;
      font-weight:400;
      color:rgba(88,88,88,1);
  }

  .copyright {
      color: #585858;
      width: 100%;
      height: 40px;
      background:rgba(227,227,227,1);
  }
  .page-main{
      height: 40px;
      line-height: 40px;
      text-align: center;
      color:rgba(88,88,88,1);
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue